module.exports = __webpack_public_path__ + "static/media/gryphon-musee-gradient.12a6b382.svg";